import { eventChannel } from 'redux-saga';

export const intervalChannel = (count = 5000) =>
    eventChannel(emitter => {
        const interval = setInterval(() => emitter(count), count);
        return () => clearInterval(interval);
    });
